"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const ERC20_ABI = require("../../abi/erc20.json");
const constants_1 = require("../../constants");
class Adapter {
    constructor(network, web3Provider, augustus) {
        this.network = network;
        this.web3Provider = web3Provider;
        this.augustus = augustus;
        this.isETHAddress = (address) => address.toLowerCase() === types_1.ETHER_ADDRESS.toLowerCase();
    }
    static getDexData(_, __) {
        throw new Error('not implemented!');
    }
    getNetworkFees(srcToken, destToken) {
        return '0';
    }
    needsAllowance(token, spender) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.isETHAddress(token)) {
                    return false;
                }
                const contract = new this.web3Provider.eth.Contract(ERC20_ABI, token);
                const allowance = yield contract.methods
                    .allowance(this.augustus._address, spender)
                    .call();
                return new bignumber_js_1.default(allowance).isLessThan(constants_1.MAX_UINT.dividedBy(2));
            }
            catch (e) {
                return true;
            }
        });
    }
    getApproveCallData(srcToken, srcAmount, exchange) {
        return __awaiter(this, void 0, void 0, function* () {
            const calldata = this.augustus.methods
                .approve(srcToken, exchange, srcAmount)
                .encodeABI();
            const needsAllowance = yield this.needsAllowance(srcToken, exchange);
            if (needsAllowance) {
                return { callee: this.augustus._address, calldata, value: '0' };
            }
            return null;
        });
    }
    swap(srcToken, destToken, data, swapData, swapExchange) {
        return __awaiter(this, void 0, void 0, function* () {
            const approveCallData = yield this.getApproveCallData(srcToken, data.srcAmount, swapExchange);
            const callees = this.isETHAddress(srcToken) || !approveCallData
                ? [swapExchange]
                : [approveCallData.callee, swapExchange];
            const calldata = this.isETHAddress(srcToken) || !approveCallData
                ? [swapData]
                : [approveCallData.calldata, swapData];
            const networkFees = this.getNetworkFees(srcToken, destToken);
            const value = new bignumber_js_1.default(data.srcAmount).plus(networkFees).toFixed(0);
            const values = this.isETHAddress(srcToken)
                ? [value]
                : approveCallData
                    ? ['0', networkFees]
                    : [networkFees];
            return {
                callees,
                calldata,
                values,
            };
        });
    }
    getBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.web3Provider.eth.getBlock('latest');
        });
    }
    getDeadline() {
        return Math.floor(new Date().getTime() / 1000) + 60 * 60;
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.isETHAddress(srcToken)) {
                    return this.ethToTokenSwap(srcToken, destToken, data);
                }
                else if (this.isETHAddress(destToken)) {
                    return this.tokenToEthSwap(srcToken, destToken, data);
                }
                else {
                    return this.tokenToTokenSwap(srcToken, destToken, data);
                }
            }
            catch (e) {
                throw new Error(e.message);
            }
        });
    }
    ethToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented!');
        });
    }
    tokenToEthSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented!');
        });
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented!');
        });
    }
}
exports.default = Adapter;
//# sourceMappingURL=adapter.js.map